import { render, staticRenderFns } from "./addwechatemplate.vue?vue&type=template&id=6b1d3dd7&scoped=true"
import script from "./addwechatemplate.vue?vue&type=script&lang=js"
export * from "./addwechatemplate.vue?vue&type=script&lang=js"
import style0 from "./addwechatemplate.vue?vue&type=style&index=0&id=6b1d3dd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1d3dd7",
  null
  
)

export default component.exports